import { render, staticRenderFns } from "./ProformaInvoiceDialog.vue?vue&type=template&id=52f95bd2"
import script from "./ProformaInvoiceDialog.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports